import React, {Component} from 'react'
import styled from 'styled-components'
import fire from '../database/firebase'

const Styles = styled.div `

    // - - HEADRR - - //

.header {
    text-align: center;
}

.header h1 {
    font-family: DM Sans;
    color: #724E39;
    margin-bottom: 2%;
}

    // - - NOTE - - //

.note {
    margin-bottom: 3%;
}

.note textarea {
    text-align: justify;
    width: 100%;
    border: 2px solid transparent;
    resize: none;
    height: 100vh;
}

// - - - - - - - - - - - PHONE DIMENSIONS - - - - - - - - - - - - - //


@media screen and (max-width: 650px) {

    .note {
        margin-left: 4.5%;
        margin-right: 4.5%;
    }

    .note textarea {
        
    }
}



`

export default class ViewNote extends Component {
    constructor(){
        super()
        this.state = {
            userEmail: null,
            note: "",
            noteID: ""
        }
    }

    componentDidMount = () => {
        fire.auth().onAuthStateChanged((user) => {
            if (user) {
                this.setState({
                    userEmail: user.email
                })
                this.getSelectedNote(user.email)
            } else {
                this.setState({user:null})
            }
        })
    }

    authListener = () => {
        fire.auth().onAuthStateChanged((user) => {
            if (user) {
                this.setState({
                    userEmail: user.email
                })
            } else {
                this.setState({user:null})
            }
        })
    }

    getSelectedNote = (email) => {
        fire.firestore().collection("users")
        .doc(email)
        .collection("savedNotes")
        .doc(this.props.dataSentFromParent)
        .get().then(doc => {
            if(doc.exists) {
                this.setState({
                    note: doc.data().note
                })
            }
        })
    }

    render () {
        return(
            <Styles>
                <div className='note'>
                    <textarea
                    value={this.state.note}
                    >
                    </textarea>
                </div>
            </Styles>
        )
    }
}